import { VideoModal } from '@aibees/shared/components';
import { LOOM_DOWNGRADE_TO_FREE_SHARE } from '@aibees/shared/constants';
import { SubscriptionModalType } from '@aibees/shared/features';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Button, Stack, Typography } from '@mui/material';
import { memo, useEffect } from 'react';
import type { DowngradeVideoDialogProps as Props } from './types';

export const DowngradeVideoDialog = memo(
  ({ className, activeModal, closeModal, onCancel, onConfirm }: Props) => {
    const state = useBoolean(false);

    useEffect(() => {
      state.setValue(activeModal === SubscriptionModalType.WATCH_VIDEO);
    }, [activeModal, state]);

    const handleContinue = () => {
      onConfirm?.();
    };

    const handleKeepPlan = () => {
      onCancel?.();
      closeModal();
    };

    return (
      <VideoModal
        className={classnames('DowngradeVideoDialog', className)}
        state={state}
        videoUrl={LOOM_DOWNGRADE_TO_FREE_SHARE}
        title="Downgrade to free?"
        titleIcon="error"
        maxWidth={false}
        paperSx={{ maxWidth: 800 }}
        onClose={closeModal}
        description={
          <Stack gap={1} mb={2}>
            <Typography variant="h6" color="grey.700">
              Sure you want to give up your premium features?
            </Typography>
            <Typography variant="body5" color="grey.500">
              Downgrading removes your plan&apos;s premium features. Watch the
              3-min video before you decide.
            </Typography>
          </Stack>
        }
        actions={
          <>
            <Button
              variant="text"
              color="inherit"
              size="small"
              onClick={handleContinue}
            >
              Continue to downgrade
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleKeepPlan}
            >
              Keep my current plan
            </Button>
          </>
        }
      />
    );
  }
);

DowngradeVideoDialog.displayName = 'DowngradeVideoDialog';
